<template>
  <div class="paragraph-component">
    <div
      :class="['paragraph',{'number' : content.number}]"
      v-for="(paragraph, index) in content.content"
      :key="index"
    >
      <p v-html="paragraph">{{paragraph}}</p>
      <h6 class="number">{{content.number}}</h6>
    </div>
    <ul class="list" v-if="content.list">
      <li v-for="(item, index) in content.list" :key="index">{{item}}</li>
    </ul>
    <div v-if="content.box" :class="['box-container', {'active': active}]">
      <h6>{{content.box.number}}</h6>
      <div class="box">{{content.box.text}}</div>
      <div class="overline"><a :href="content.box.link" target="_blank">{{content.box.source}}</a></div>
    </div>
    <div v-if="content.note">
      <div class="overline" v-html="content.note">{{content.note}}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["content", "active"]
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";

.paragraph-component {
  max-width: 588px;
  margin: 0 auto;
  .paragraph {
    &.number {
      position: relative;
      h6 {
        position: absolute;
        top: -5px;
        left: 15px;
        // -webkit-text-stroke: 3px black;
      }

      p::first-letter {
        font-family: "IBMPlexSerif";
        font-size: 80px;
        font-weight: bold;
        line-height: 80px;
        margin: 0em 0.2em;
        float: left;
        color: white;
      }
    }
  }
  .box-container {
    width: 260px;
    border: solid 3px $terna-blu;
    margin: 0 25px 5px -100px;
    float: left;
    -webkit-shape-outside: polygon(100px 100px 100px 100px 10px);
    shape-outside: polygon(100px 100px 100px 100px 10px);
    padding: 24px !important;
    h6 {
      // color: white;
      // -webkit-text-stroke: 2px black;
      opacity: 0.5;
      transition: all 0.5s ease;
    }
    .overline {
      margin-top: 10px;
      a {
        color: black;
      }
    }
    &.active {
      h6 {
        opacity: 1;
      }
    }
  }
  .list li {
    position: relative;
    list-style: none;
    &::before {
      position: absolute;
      top: 11px;
      left: -22px;
      content: "";
      height: 8px;
      width: 8px;
      border: solid 1px black;
    }
  }
}
@media (max-width: 768px) {
  .paragraph-component {
    max-width: 100%;
    padding: 0 15px;
    .box-container {
      width: 100%;
      border: solid 3px black;
      margin: 0;
      float: none;
      padding: 24px !important;
      h6 {
        color: white;
        -webkit-text-stroke: 3px black;
      }
      .overline {
        margin-top: 10px;
      }
    }
  }
}
</style>
